import { useState, useEffect } from 'react'

import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { useUserAuth } from '../../context/UserAuthContext';

import axios from 'axios';

import dayjs from 'dayjs';



const CalendarList = () => {

    const { user , token} = useUserAuth();

    const merchant_id = user.uid;

    const [events, setEvents] = useState([])

    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

    useEffect(() => {
        if (!merchant_id) return
        const getSingleDocumentHandler = async () => {

            try {

                const response = await axios.get(`${base_url}/api/v1/availability/vendor_id/${merchant_id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                console.log(response.data)

                setEvents(response.data.data);

            } catch (error) {

                console.log(`Error ${error} `)

            }

        }

        getSingleDocumentHandler()

    }, [merchant_id])

    const btnHander = async (id) => {

        try {

            const response = await axios.delete(`${base_url}/api/v1/availability/${id}`);

            console.log(response.data)

            setEvents((prevEvents) => prevEvents.filter((event) => event.id !== id));

            toast.success('Event deleted successfully')

        } catch (err) {

            console.log(err)

        }

    }

    return (

        <div className="page-wrapper">

            <div className="container-fluid">

                <div className="row">

                    <div className="col-md-12">

                        <div className="card">

                            <div className='card-header bg-white'>

                                <p><b>Calendar Data</b></p>

                            </div>

                            <div className='card-body'>

                                <div className='table-responsive'>

                                    <table className='table table-bordered'>

                                        <thead>

                                            <tr>

                                                <th>S.No.</th>

                                                <th>Name</th>

                                                <th>Email</th>

                                                <th>Title</th>

                                                <th>Start Date </th>

                                                <th>End Date</th>

                                                <th>Status</th>

                                                <th>Payment Status</th>

                                                <th>Created At</th>

                                                <th>Action</th>

                                            </tr>

                                        </thead>

                                        <tbody>



                                            {

                                                events?.map((item, index) => {

                                                    return (

                                                        <tr key={item.id}>

                                                            <td>{index + 1}</td>

                                                            <td>

                                                                {item.user_name}

                                                            </td>

                                                            <td>

                                                                {item.user_email || 'NaN'}

                                                            </td>

                                                            <td>{item.title}</td>

                                                            <td>{item.start_date}</td>

                                                            <td>{item.end_date}</td>

                                                            <td>

                                                                <div style={{ height: '20px', width: '20px', borderRadius: '50%', backgroundColor: item.color }}>

                                                                </div>

                                                            </td>

                                                            <td>

                                                                <button className={`btn btn-sm text-white ${(item.payment_status === 'pending') ? 'bg-warning' : 'bg-success'}`}>{item.paymentStatus}</button>

                                                            </td>

                                                            <td>

                                                                {dayjs(item.created_at).format('DD MMM, YYYY')}

                                                            </td>

                                                            <td>

                                                                <button className='btn btn-danger btn-sm' onClick={() => btnHander(item.id)}>Delete</button>

                                                            </td>

                                                        </tr>

                                                    )

                                                })

                                            }

                                        </tbody>

                                    </table>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    )

}



export default CalendarList